/* CANIPANI — Interface : bandeau d'annonce, accordéons exclusifs, divers */

(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  /* ------------------------------------------------- Bandeau d'annonce */

  document.querySelectorAll('[data-announcement]').forEach(function (bar) {
    var items = bar.querySelectorAll('[data-announcement-item]');
    var close = bar.querySelector('[data-announcement-close]');
    var delay = Number(bar.getAttribute('data-interval') || 5000);
    var index = 0;
    var timer = null;

    if (close) {
      close.addEventListener('click', function () {
        bar.hidden = true;
        window.clearInterval(timer);
        try { window.sessionStorage.setItem('canipani:announcement', 'closed'); } catch (e) {}
        document.dispatchEvent(new CustomEvent('layout:changed'));
      });
      try {
        if (window.sessionStorage.getItem('canipani:announcement') === 'closed') bar.hidden = true;
      } catch (e) {}
    }

    if (items.length < 2) return;

    timer = window.setInterval(function () {
      items[index].setAttribute('data-active', 'false');
      index = (index + 1) % items.length;
      items[index].setAttribute('data-active', 'true');
    }, delay);

    bar.addEventListener('mouseenter', function () { window.clearInterval(timer); });
  });

  /* --------------------------------- Accordéons exclusifs (un seul ouvert) */

  document.querySelectorAll('[data-accordion-exclusive]').forEach(function (group) {
    var items = group.querySelectorAll('details');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) { if (other !== item) other.open = false; });
      });
    });
  });

  /* ------------------------------------------- Défilement vers une ancre */

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-scroll-to]');
    if (!link) return;
    var target = document.querySelector(link.getAttribute('data-scroll-to'));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });
})();

/* Replie les sections longues sur petit écran. Le HTML reste ouvert :
   le contenu est indexable et lisible sans JavaScript. */
(function () {
  'use strict';
  function replier() {
    var petit = window.matchMedia('(max-width: 749px)').matches;
    document.querySelectorAll('[data-accordeon-mobile]').forEach(function (d) {
      if (petit && d.dataset.replie !== '1') { d.open = false; d.dataset.replie = '1'; }
      if (!petit) { d.open = true; }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replier);
  } else { replier(); }
  window.addEventListener('resize', replier);
  document.addEventListener('shopify:section:load', replier);
})();
